import React from "react";
import useAuth from "../../hooks/useAuth";
import OldBillingMIS from "./OldBillingMIS";
import BillingMIS from "./BillingMIS";

const ManageBillingMIS = () => {
    const { user } = useAuth();
    return <>{user && <BillingMIS />}</>;
};

export default ManageBillingMIS;
